/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { AppNavCancelButton } from './appNavBits/AppNavButtons';
import MedliSearchControl from './appNavBits/MedliSearchControl';
import { NavigationRow, SearchRow } from './appNavBits/AppNavRow';
import AppNavContent from './appNavBits/AppNavContent';

import { userSelectors } from '../../redux/selectors_authorizedApp';
import { selectors as listSelectors } from '../../redux/ducks/lists/lists';


function mapStateToProps(state) {
  const localeMedliOptionList = listSelectors.getLocaleMedliCollection(state).map((item) => ({
    value: item.language_code,
    labelId: `${item.key}.name`,
  }));

  return {
    initialMedliLocale: userSelectors.getDefaultMedliLocale(state),
    localeMedliOptionList,
  };
}

class AppNavMedliSearch extends React.Component {

  constructor(props) {
    super(props);
    this.submitSearch = this.submitSearch.bind(this);
    this.onChange = this.onChange.bind(this);
    this.clearField = this.clearField.bind(this);

    this.state = {
      searchQuery: this.props.query || '',
      medliLocale: props.initialMedliLocale,
    };
  }

  onChange(event) {
    this.setState({
      searchQuery: event.target.value,
    });
    this.props.actions.onChangeQuery();
  }

  submitSearch() {
    this.props.actions.submitSearch({
      query: this.state.searchQuery,
      languageCode: this.state.medliLocale.language_code,
      category: this.props.medliCategory,
    });
  }

  clearField() {
    this.setState({
      searchQuery: '',
    });
  }

  render() {
    return (
      <AppNavContent>
        <NavigationRow>
          <AppNavCancelButton onClick={this.props.actions.cancelSearch} color="white" />
        </NavigationRow>

        <SearchRow>
          <MedliSearchControl
            onChange={this.onChange}
            submitSearch={this.submitSearch}
            value={this.state.searchQuery}
            hasInitialFocus={this.props.hasInitialFocus}
            placeholder={this.props.queryPlaceholder}
            clearField={this.clearField}
            medliLocaleId={this.state.medliLocale.id}
            onChangeMedliLanguage={(medliLocale) => {
              this.setState({ medliLocale });
            }}
          />
        </SearchRow>
      </AppNavContent>
    );
  }
}
AppNavMedliSearch.propTypes = {
  initialMedliLocale: PropTypes.object.isRequired,
  localeMedliOptionList: PropTypes.array.isRequired,
  medliCategory: PropTypes.string,
  query: PropTypes.string,
  queryPlaceholder: PropTypes.string,
  hasInitialFocus: PropTypes.bool,
  actions: PropTypes.shape({
    cancelSearch: PropTypes.func.isRequired,
    submitSearch: PropTypes.func.isRequired,
    onChangeQuery: PropTypes.func.isRequired,
  }),
};

export default connect(mapStateToProps)(AppNavMedliSearch);
